/* ==========================================================================
   One Gotta Go — Shopify 2.0 Theme JavaScript
   Vanilla JS, no dependencies

   NOTE: Mobile menu, cart drawer, variant selection, and product form
   add-to-cart are handled by inline scripts in their respective
   Liquid templates (header.liquid, cart-drawer.liquid, main-product.liquid).
   ========================================================================== */

(function () {
  'use strict';

  /* ========================================================================
     1. Sticky Header — adds .scrolled class at 50px scroll
     ======================================================================== */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var scrollThreshold = 50;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (window.scrollY > scrollThreshold) {
            header.classList.add('scrolled');
          } else {
            header.classList.remove('scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ========================================================================
     2. Announcement Bar Dismiss — sessionStorage
     ======================================================================== */
  function initAnnouncementBar() {
    var bar = document.querySelector('.announcement-bar');
    var dismissBtn = document.querySelector('.announcement-dismiss');
    if (!bar) return;

    if (sessionStorage.getItem('ogg_announcement_dismissed') === 'true') {
      bar.classList.add('dismissed');
      return;
    }

    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        bar.classList.add('dismissed');
        sessionStorage.setItem('ogg_announcement_dismissed', 'true');
      });
    }
  }

  /* ========================================================================
     3. FAQ Accordion — toggle open/close, single open at a time
     ======================================================================== */
  function initFAQ() {
    var faqQuestions = document.querySelectorAll('.faq-question');
    if (!faqQuestions.length) return;

    faqQuestions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.closest('.faq-item');
        var wasOpen = item.classList.contains('open');

        // Close all
        document.querySelectorAll('.faq-item').forEach(function (i) {
          i.classList.remove('open');
        });

        // Toggle current
        if (!wasOpen) {
          item.classList.add('open');
        }
      });
    });

    // Also expose globally for inline onclick handlers in Liquid templates
    window.toggleFaq = function (btn) {
      var item = btn.parentElement;
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
      });
      if (!wasOpen) item.classList.add('open');
    };
  }

  /* ========================================================================
     4. Count-Up Animation on Stats — IntersectionObserver
     ======================================================================== */
  function initCountUp() {
    var statNumbers = document.querySelectorAll('.stat-number[data-target]');
    if (!statNumbers.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-target'), 10);
          if (isNaN(target)) return;

          var duration = 2000;
          var start = performance.now();

          function update(now) {
            var elapsed = now - start;
            var progress = Math.min(elapsed / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = Math.floor(eased * target);
            el.textContent = current.toLocaleString() + (target >= 100 ? '+' : '');
            if (progress < 1) {
              requestAnimationFrame(update);
            }
          }

          requestAnimationFrame(update);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    statNumbers.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ========================================================================
     5. Scroll Reveal — .step, .deck-card, .review-card fade up on scroll
     ======================================================================== */
  function initScrollReveal() {
    var revealEls = document.querySelectorAll('.step, .deck-card, .review-card');
    if (!revealEls.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    revealEls.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

  /* ========================================================================
     6. Ticker Seamless Loop — duplicate ticker-inner content
     ======================================================================== */
  function initTicker() {
    var tickerInner = document.querySelector('.ticker-inner');
    if (!tickerInner) return;

    var children = tickerInner.children;
    var originalCount = children.length;

    if (originalCount > 0 && originalCount < 12) {
      var fragment = document.createDocumentFragment();
      for (var i = 0; i < originalCount; i++) {
        fragment.appendChild(children[i].cloneNode(true));
      }
      tickerInner.appendChild(fragment);
    }
  }

  /* ========================================================================
     7. Quantity +/- Buttons (delegated)
     ======================================================================== */
  function initQuantityButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.quantity-selector button');
      if (!btn) return;

      var selector = btn.closest('.quantity-selector');
      var input = selector ? selector.querySelector('input') : null;
      if (!input) return;

      var current = parseInt(input.value, 10) || 1;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var max = parseInt(input.getAttribute('max'), 10) || 99;

      if (btn.getAttribute('data-action') === 'decrease' || btn.textContent.trim() === '-') {
        if (current > min) input.value = current - 1;
      } else {
        if (current < max) input.value = current + 1;
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ========================================================================
     8. Newsletter AJAX Submit
     ======================================================================== */
  function initNewsletter() {
    var forms = document.querySelectorAll('.newsletter-form');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var emailInput = form.querySelector('input[type="email"]');
        var submitBtn = form.querySelector('button');
        var successMsg = form.parentElement
          ? form.parentElement.querySelector('.newsletter-success')
          : null;

        if (!emailInput || !emailInput.value) return;

        var originalText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending...';
        }

        var formData = new FormData();
        formData.append('form_type', 'customer');
        formData.append('utf8', '\u2713');
        formData.append('customer[email]', emailInput.value);
        formData.append('customer[tags]', 'newsletter');

        fetch('/contact', {
          method: 'POST',
          body: formData
        })
          .then(function () {
            emailInput.value = '';
            if (submitBtn) {
              submitBtn.textContent = 'Subscribed!';
              submitBtn.disabled = false;
            }
            if (successMsg) {
              successMsg.classList.add('show');
            }
            setTimeout(function () {
              if (submitBtn) submitBtn.textContent = originalText;
              if (successMsg) successMsg.classList.remove('show');
            }, 4000);
          })
          .catch(function () {
            if (submitBtn) {
              submitBtn.textContent = 'Error - Try Again';
              submitBtn.disabled = false;
            }
            setTimeout(function () {
              if (submitBtn) submitBtn.textContent = originalText;
            }, 3000);
          });
      });
    });
  }

  /* ========================================================================
     9. Search Overlay — open/close
     ======================================================================== */
  function initSearch() {
    var overlay = document.querySelector('.search-overlay');
    var closeBtn = document.querySelector('.search-overlay-close');
    var searchInput = document.querySelector('.search-overlay-input');
    var openTriggers = document.querySelectorAll('[data-search-toggle]');

    if (!overlay) return;

    function openSearch() {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (searchInput) {
        setTimeout(function () { searchInput.focus(); }, 100);
      }
    }

    function closeSearch() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    openTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openSearch();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) {
        closeSearch();
      }
    });

    if (searchInput) {
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          var query = searchInput.value.trim();
          if (query) {
            window.location.href = '/search?q=' + encodeURIComponent(query);
          }
        }
      });
    }
  }

  /* ========================================================================
     10. Demo Vote Interaction (hero banner)
     ======================================================================== */
  function initDemoVote() {
    var voted = false;

    window.vote = function (el, pct) {
      if (voted) return;
      voted = true;

      var choices = document.querySelectorAll('.demo-choice');
      choices.forEach(function (c) { c.style.pointerEvents = 'none'; });
      el.classList.add('voted');

      var minPct = 100;
      var minEl = null;
      choices.forEach(function (c) {
        var pctEl = c.querySelector('.vote-pct');
        if (!pctEl) return;
        var p = parseInt(pctEl.textContent, 10);
        if (c !== el && p < minPct) {
          minPct = p;
          minEl = c;
        }
      });

      if (minEl) {
        setTimeout(function () {
          minEl.classList.add('eliminated');
          var choiceText = minEl.querySelector('.choice-text');
          if (choiceText) choiceText.textContent = '\u2715 ELIMINATED';
        }, 600);
      }
    };
  }

  /* ========================================================================
     11. Card ATC inline quantity picker (homepage/collection)
     ======================================================================== */
  function initCardATCQty() {
    document.addEventListener('click', function (e) {
      var atcBtn = e.target.closest('.card-atc-btn');
      var qtyBtn = e.target.closest('.card-atc-qty__btn');

      /* ATC button first click: show qty picker */
      if (atcBtn) {
        var wrap = atcBtn.closest('.card-atc-wrap');
        if (wrap && !wrap.classList.contains('qty-active')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          wrap.classList.add('qty-active');
          return;
        }
      }

      /* Qty +/- buttons */
      if (qtyBtn) {
        e.preventDefault();
        e.stopPropagation();
        var wrap = qtyBtn.closest('.card-atc-wrap');
        var valueEl = wrap.querySelector('.card-atc-qty__value');
        var input = wrap.closest('form').querySelector('.card-qty-input');
        var qty = parseInt(valueEl.textContent, 10) || 1;
        if (qtyBtn.getAttribute('data-action') === 'decrease') {
          qty = Math.max(1, qty - 1);
        } else {
          qty = Math.min(99, qty + 1);
        }
        valueEl.textContent = qty;
        input.value = qty;
      }

      /* Click outside to close */
      if (!e.target.closest('.card-atc-wrap')) {
        document.querySelectorAll('.card-atc-wrap.qty-active').forEach(function (w) {
          w.classList.remove('qty-active');
        });
      }
    });
  }

  /* ========================================================================
     Initialize all modules on DOMContentLoaded
     ======================================================================== */
  function init() {
    initStickyHeader();
    initAnnouncementBar();
    initFAQ();
    initCountUp();
    initScrollReveal();
    initTicker();
    initQuantityButtons();
    initCardATCQty();
    initNewsletter();
    initSearch();
    initDemoVote();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
